import styled from '@emotion/styled'
import {
    playButtonStates,
    StyledPlayButton,
} from '../../../../buttons/PlayButton/PlayButton.styled'
import { easing } from '../../../../__styling/settings/easing'
import { zIndex } from '../../../../__styling/settings/z-index'
import { hexToRGBA } from '../../../../__styling/style-mixins'
import { themedValue } from '../../../../__styling/themed-value'
import { colors } from '../../../../__styling/settings/colors'

// This creates the overlay class and passes it into the PlayOverlayComponent
export const StyledPlayOverlay = styled('div')(
    {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        cursor: 'pointer',
    },

    ({ theme }) => ({
        transition: themedValue(theme, {
            sevennews: `background ${easing.easeOut.fast}`,
            thenightly: `background ${easing.easeOut.fast}`,
            fallback: undefined,
        }),
        zIndex: themedValue(theme, {
            sevennews: zIndex.common.videoPlayButton,
            thenightly: zIndex.common.videoPlayButton,
            fallback: undefined,
        }),
        [`& ${StyledPlayButton}`]: {
            pointerEvents: themedValue(theme, {
                sevennews: 'none',
                thenightly: 'none',
                fallback: undefined,
            }),
        },
        ...playButtonStates(theme),
        '&:hover': {
            background: themedValue(theme, {
                sevennews: (section) =>
                    hexToRGBA(section.video.playOverlay, 0.3),
                thenightly: hexToRGBA(colors.thenightly.neutral[100], 0.3),
                fallback: undefined,
            }),
            button: {
                backgroundColor: themedValue(theme, {
                    sevennews: (section) =>
                        hexToRGBA(section.video.playOverlay, 0.5),
                    fallback: undefined,
                }),
            },
        },
        '&:active, &:focus': {
            border: themedValue(theme, {
                sevennews: (section) => `2px solid ${section.video.focusColor}`,
                thenightly: `2px solid ${colors.thenightly.neutral[100]}`,
                fallback: undefined,
            }),
            margin: themedValue(theme, {
                thenightly: '-6px',
                fallback: undefined,
            }),
            borderRadius: themedValue(theme, {
                thenightly: '4px',
                fallback: undefined,
            }),
        },
    }),
)
